import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-equal-face-analytics',
  templateUrl: './equal-face-analytics.component.html',
  styleUrls: ['./equal-face-analytics.component.css']
})
export class EqualFaceAnalyticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
